import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import _PaymentIQCashier, { CashierConfig, IPiqCashierApiMethods } from 'paymentiq-cashier-bootstrapper';
import { timer } from 'rxjs';
import { CardDepositService } from 'src/app/pages/wallet/deposit-withdraw/deposit-crypto-piq/card-deposit/card-deposit.service';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { PaymentIQData } from 'src/app/shared/interfaces/deposit.interface';
import { WalletDialogType, WalletService } from '../wallet.service';

@UntilDestroy()
@Component({
  selector: 'app-payment-iq',
  standalone: true,
  templateUrl: './payment-iq.component.html',
  styleUrls: ['./payment-iq.component.scss'],
  imports: [LoadingModule],
})
export class PaymentIqComponent implements OnInit {
  constructor(
    private walletService: WalletService,
    private cardDepositService: CardDepositService,
  ) {}

  loading: boolean = true;

  configCashier!: CashierConfig;

  paymentIQ?: _PaymentIQCashier;

  /** Deposit or Withdrawal */
  @Input() method!: CashierConfig['method'];

  /** Payment Data */
  @Input() curPaymentData!: PaymentIQData;

  ngOnInit() {
    this.onBootWindow();
  }

  onBootWindow() {
    this.onClearCashier()
      .pipe(untilDestroyed(this))
      .subscribe(_ => {
        this.onConfigCashier();
      });
  }

  /**
   * 配置 PaymentIQ
   */
  onConfigCashier() {
    const { pspMerchantId: merchantId, userId, sessionId, amount, environment } = this.curPaymentData.config;

    this.configCashier = {
      userId,
      merchantId,
      sessionId,
      amount,
      environment,
      attributes: {
        gmOrderId: sessionId,
      },
      method: this.method,
      defaultLoader: false,
      customLogoFileName: '',
      gtm: '',
      locale: 'en',
      allowMobilePopup: 'true',
      containerWidth: '100%',
      containerHeight: '567px',
      containerMinHeight: '400px',
      accountDelete: 'true',
      allowCancelPendingWithdrawal: 'false',
      amountFirst: 'false',
      autoOpenFirstPaymentMethod: 'true',
      autoProcess: 'false',
      displayLogoOrName: 'both',
      globalSubmit: 'true',
      layout: 'vertical',
      listRadio: 'false',
      listType: 'list',
      logoFullWidth: 'true',
      logoSize: 120,
      mode: 'ecommerce',
      predefinedValues: 'false',
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      showCookiesWarning: 'false',
      selectlastusedtxmethod: 'false',
      showAccounts: 'list-first',
      showAmountLimits: 'true',
      showBonusCode: 'false',
      showFee: 'true',
      showFooter: 'false',
      showHeader: 'false',
      showListHeaders: 'true',
      showTermsConditions: 'false',
      showTransactionOverview: 'true',
      singlePageFlow: 'true',
      storeAccount: 'true',
      tabs: 'false',
      theme: {
        input: {
          height: '46px',
          color: '#1e2329',
        },
        inputbackground: {
          color: '#f0f0f0',
        },
        labels: {
          color: '#1e2329',
        },
        loader: {
          color: 'transparent',
        },
        buttons: {
          color: '#007547',
        },
        cashierbackground: {
          color: '',
        },
        headings: {
          color: '#1e2329',
        },
      },
    };
    this.onCreateCashier();
  }

  /** 建立 PaymentIQ 界面 */
  onCreateCashier() {
    this.loading = true;
    this.paymentIQ = new _PaymentIQCashier('#cashier', this.configCashier, (api: IPiqCashierApiMethods) => {
      api.on({
        cashierInitLoad: () => console.log('Cashier init load'),
        update: data => console.log('The passed in data was set', data),
        success: data => {
          if (data?.data?.payload.success) {
            this.cardDepositService.closeCardModal();
            this.walletService.openWallet(WalletDialogType.DEPOSIT_TRANSACTION_DETAILS);
            this.showDepositDetails();
          }
          console.log('Transaction was completed successfully', data);
        },
        failure: data => {
          if (!data?.data.success) {
            console.log('Transaction failed', data);
          }
          console.log('Transaction failed', data);
        },
        pending: data => console.log('Transaction is pending', data),
        unresolved: data => console.log('Transaction is unresolved', data),
        isLoading: data => console.log('Data is loading', data),
        doneLoading: data => {
          this.loading = false;
          console.log('Data has been successfully downloaded', data);
        },
        newProviderWindow: data => console.log('A new window / iframe has opened', data),
        paymentMethodSelect: data => console.log('Payment method was selected', data),
        paymentMethodPageEntered: data => console.log('New payment method page was opened', data),
        navigate: data => console.log('Path navigation triggered', data),
        cancelledPendingWD: data => console.log('A pending withdrawal has been cancelled', data),
        validationFailed: data => {
          console.log('Transaction attempt failed at validation', data);
        },
        cancelled: data => console.log('Transaction has been cancelled by user', data),
        onLoadError: data => {
          console.log('Cashier could not load properly', data);
        },
        transactionInit: data => console.log('A new transaction has been initiated', data),
      });
    });
  }

  /** 切換主題時清除 PaymentIQ 界面 */
  @ViewChild('cashier') cashierElement!: ElementRef<any>;
  onClearCashier() {
    if (this.cashierElement) {
      this.cashierElement.nativeElement.innerHTML = '';
      this.paymentIQ = undefined;
    }
    return timer(200);
  }

  /** 顯示充值詳情 */
  showDepositDetails() {
    this.walletService.walletDetailsData = {
      status: 'success',
      header: 'Buy Crypto',
      title: '',
      content: '',
      typeTitle: 'Deposit',
      data: {
        txId: this.curPaymentData.config.orderId,
        amount: this.curPaymentData.getAmount,
        currency: this.curPaymentData.getAmountCurrency,
      },
      orderStatus: 'success',
    };
  }
}
